<template lang="pug">
.container.text-left.event-box
  invite-modal
  .row
    .col-12.title-row
      h4.text-center Events
      div.btn-green.float-right(v-b-modal.create-event='', v-if='eventList.length > 0') Create Event
  .row.events-row.justify-content-center(v-if='allEvents.length > 0')
    .col-12.tabs.d-flex.justify-content-center
      .tab(:class='{active: page === "active"}', @click='page = "active"') Active
      .tab(:class='{active: page === "completed"}', @click='page = "completed"') Completed
    .event.col-12.col-lg-4(
      v-for='event in eventList',
      :key='event._id')
      event-item(:event='event')
  .row.events-row.empty-state.d-flex.justify-content-center(v-if='allEvents.length === 0')
    // @TODO: component
    .card-wrap.text-center
      img.compass(src='../../assets/nav/compass.svg')
      h3 Create Your First Event!
      p
        | Events are battles your sprite enters to earn a bunch of experience and level up!
        | Progress through events by completing activities in your integrated apps.
      .btn-green(v-b-modal.create-event='') Create Event
  .row.events-row.empty-state.d-flex.justify-content-center(v-else-if='eventList.length === 0')
    div.text-center
      h5 No Active Events
      p Events help you set and track goals while giving your participating Sprite a lot of experience.
      div.btn-green(v-b-modal.create-event='') Create Event
</template>

<style lang="scss" scoped>
  .title-row {
    position: relative;

    h4 {
      margin-top: .5em;
      margin-bottom: 1em;
      width: 100%;
      font-size: 24px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: 3px;
      text-align: center;
      text-transform: uppercase;
      color: #6c6d69;
    }

    .btn-green {
      position: absolute;
      right: 0;
      top: 10px;
    }
  }

  .event-box {
    margin-top: 4em;
    margin-bottom: 4em;
  }

  .events-row {
    border-radius: 4px;
    padding: 1em 1em;
    padding-top: 1.5em;

    .tabs {
      margin-bottom: 1rem;
    }

    .event:hover {
      cursor: pointer;
    }

    .event {
      margin-bottom: 1em;
    }

    .create-event {
      border: 4px solid #F3F5F7;
      padding: 2em;
    }

    .create-event:hover {
      cursor: pointer;
    }
  }
</style>

<script>
import InviteModal from '../InviteModal';
import EventItem from './EventItem';

export default {
  components: {
    InviteModal,
    EventItem,
  },
  data() {
    return {
      githubIconSVG: '../../assets/sprite-2.svg',
      page: 'active',
    };
  },
  computed: {
    allEvents() {
      return this.$store.state.events;
    },
    eventList() {
      const filtered = this.allEvents.filter((event) => {
        const defeated = event.eventOptions.status === 'defeat';
        return this.page === 'active' ? (!event.completed && !defeated) : (event.completed || defeated);
      });

      return filtered;
    },
  },
  methods: {
    createEvent() {
      this.$router.push({ name: 'EventCreate' });
    },
    // @TODO move event to cmponent and make these cmputed
    invite(eventId) {
      this.$store.state.eventId = eventId;
      this.$root.$emit('bv::show::modal', 'invite-detail');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/events/EventBox.vue